import { FormField } from '@/_components';
import { Address } from '@/_containers';
import { showFormField } from '@/_shared';

import type { AddressSectionProps } from './types';

import { useGovernanceFormContext } from '../../form-context';

export function AddressSection({ isEdit, onRequestEdit }: AddressSectionProps) {
  const form = useGovernanceFormContext();

  const [addresses] = form.watch(['registered_agent_addresses']);

  return (
    showFormField(isEdit, addresses?.[0]) && (
      <FormField
        control={form.control}
        name="registered_agent_addresses"
        render={({ field }) => (
          <Address
            type="billing"
            text="Registered Agent Address"
            value={addresses?.[0]}
            isEdit={isEdit}
            onChange={field.onChange}
            onRequestEdit={onRequestEdit}
          />
        )}
      />
    )
  );
}
